type PaginationItemValue = string | number

export type Pagination = {
  limit: PaginationItemValue
  offset: PaginationItemValue
  total: PaginationItemValue
}

const USER_ROLES = {
  '1': 'A2',
  '2': 'A3',
  '3': 'A4',
  '4': 'A5'
}

export const USER_STATUS_COLOR_MAP = {
  1: { color: '#8DB73D', class: 'active' },
  2: { color: '#FF4C51', class: 'warning' },
  3: { color: '#FF4C51', class: 'warning' },
}

export const REGISTRATION_STATUS_COLOR_MAP = {
  1: { color: '#00BAD1', class: 'active' },
  2: { color: '#8DB73D', class: 'active' },
  3: { color: '#FF4C51', class: 'warning' },
  4: { color: '#FF4C51', class: 'warning' },
}

export const MODERATION_STATUS_COLOR_MAP = {
  1: { color: '#00BAD1', class: 'confirmed' },
  2: { color: '#8DB73D', class: 'new' },
  3: { color: '#FF4C51', class: 'warning' },
  4: { color: '#FF4C51', class: 'warning' },
}

export const PUBLICATION_STATUS_COLOR_MAP = {
  0: { color: '#878787', class: 'warning' },
  1: { color: '#8DB73D', class: 'active' },
}

export const PHONE_WAY = 'phone'

export const userRole = window.userRole
export const langCode = window.language
export const captchaKey = window.captcha_key
export const isAuth = window.isAuth
export const userStatuses = window.userStatuses
export const bonusTypes = window.bonusTypes
export const moderationStatuses = window.moderationStatuses
export const motivationStatuses = window.motivationStatuses
export const articleStatuses = window.articleStatuses
export const languagesList = window.languagesList

export const logo_main = window.logo_main
export const logo_alternative = window.logo_alternative

export const MOBILEREG = /^(?:\+380|0)\d{9}$/

export const EMAILREG = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const PASSWORD_MIN_LENGTH = 7
export const PASSWORD_REG = /^(?=.*?[A-ZА-Я])(?=.*?[a-zа-я])(?=.*?[0-9]).*$/;
